import { useHomepageTiles } from '../../../common/Experiments/HomepageTilesExperiment';
import { SpecialtyLabelMobile, SpecialtyLabelDesktop } from './SearchSpecialtySelector.styles';

interface SpecialtyLabelSwitcherProps {
  desktopLabel: string;
  mobileLabel?: string | null;
}

export const SpecialtyLabelSwitcher = ({
  desktopLabel,
  mobileLabel,
}: SpecialtyLabelSwitcherProps) => {
  const homepageTilesExperiment = useHomepageTiles();
  return (
    <>
      {mobileLabel && (
        <SpecialtyLabelMobile experiment={homepageTilesExperiment}>
          {mobileLabel}
        </SpecialtyLabelMobile>
      )}
      <SpecialtyLabelDesktop experiment={homepageTilesExperiment} hiddenMobile={!!mobileLabel}>
        {desktopLabel}
      </SpecialtyLabelDesktop>
    </>
  );
};
